<section class="p-6">
  <div class="m-t-16 no print flex flex-row gap-2">
    <button type="button" mat-stroked-button color="primary" (click)="print()">
      Print
    </button>

    <button type="button" mat-stroked-button color="primary" (click)="pdf.saveAs('Program_Summary.pdf')">
      Export to PDF
    </button>

    <button type="button" mat-stroked-button color="warn" (click)="cancel()">Close</button>
  </div>
</section>
<mat-dialog-content style="color:black">
  <kendo-pdf-export #pdf
                    paperSize="letter"
                    [scale]="0.75"
                    margin="1cm">
    <ng-template kendoPDFTemplate
                  let-pageNum="pageNum"
                  let-totalPages="totalPages">
      <div style="position: absolute; bottom: 0; left: 0; right: 0; text-align: center; font-size: 12px; border-top: 1px solid black; padding-top: 4px;">
          Oregon Psilocybin Services | PO Box 14450, Portland OR 97293-0450 <br>OHA.Psilocybin@oha.oregon.gov | www.Oregon.gov/psilocybin
      </div>
    </ng-template>
    <div id="certificate" #certificate style="width:100%; position:relative;" class="f-s-16 flex flex-col gap-2">
    <div style="position:absolute; inset:0; background-image:url('assets/images/transparentSeal.png'); background-repeat:no-repeat; background-position:center; background-size:contain; opacity:0.25; pointer-events:none; z-index:0;"></div>
    <div style="position:relative; z-index:1;" class="flex flex-col gap-2">
      <div class="flex flex-row gap-2">
        <!-- <div class="flex flex-col flex-1">
          <span class="f-s-18"><strong>PUBLIC HEALTH DIVISION</strong></span>
          <span class="f-s-18"><strong>CENTER FOR HEALTH PROTECTION</strong></span>
          <span><strong>Oregon Psilocybin Services</strong></span>
          <span><a href="http://oregon.gov/psilocybin">http://oregon.gov/psilocybin</a></span>
        </div> -->
        <img class="p-4" src="../../../../../assets/images/OHA-Color-Small.png" alt="OHA Logo" class="block ml-auto">
      </div>

      <h3 style="border-bottom: 1px solid currentColor; padding-bottom: 4px;">Psilocybin Training Program Curriculum Approval</h3>
      <div class="p-t-8 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Training Program Name</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{program.programName}}</span>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span><strong>Program ID</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{program.programId}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-8 flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Address</strong></span>
          <span>Headquarters Address</span>
          <div class="flex flex-row gap-2">
            <span>{{program.headquartersStreet}} {{program.headquartersCity}}, {{program.headquartersState}} {{program.headquartersZip}} {{program.headquartersCounty}}</span>
          </div>
          <span *ngIf="!program.mailingIsHeadquarters">Mailing Address</span>
          <div class="flex flex-row gap-2" *ngIf="!program.mailingIsHeadquarters">
            <span>{{program.mailingStreet}} {{program.mailingCity}}, {{program.mailingState}} {{program.mailingZip}} {{program.mailingCounty}}</span>
          </div>
          <span *ngIf="!program.facilityIsHeadquarters">Physical Address</span>
          <div class="flex flex-row gap-2" *ngIf="!program.facilityIsHeadquarters">
            <span>{{program.facilityStreet}} {{program.facilityCity}}, {{program.facilityState}} {{program.facilityZip}} {{program.facilityCounty}}</span>
          </div>
        </div>
      </div>

      <h3 style="border-bottom: 1px solid currentColor; padding-bottom: 4px;">Psilocybin Training Program Curriculum Approval Information</h3>
      <div class="p-t-8 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Approved Date</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{program.grantedDate}}</span>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span><strong>Expiration Date</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{program.expirationDate}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-8 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Responsible Party</strong></span>
          <div class="p-t-8 flex flex-col gap-2">
            <span>{{responsibleParty?.firstName}} {{responsibleParty?.lastName}}</span>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span><strong>Staff</strong></span>
          <div *ngFor="let contact of program.trainingProgramContacts" class="flex flex-row gap-2">
            <span>{{contact.firstName}} {{contact.lastName}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-8 flex flex-row gap-4 justify-between items-center">
        <div class="flex flex-col gap-2">
          <span><strong>Licensing Manager Signature</strong></span>
          <div class="flex flex-row gap-2">
            <img src="assets/images/manager-signature.png" alt="Licensing Manager Signature" style="max-height: 50px; margin-left: -25px;">
          </div>
        </div>
        <qrcode [qrdata]=" url + '/license-information/'+ 'TrainingProgram/' + program.id"></qrcode>
      </div>
    </div>
    </div>
  </kendo-pdf-export>
</mat-dialog-content>
